import { useEffect, useState } from 'react';
import { cdoBiome } from '../cdo/cdoTemplateCatalog.js';
import '../styles/BeingTemplateEditor.css';

export default function EntityBiomeFields({ value = [], onChange }) {
  const [catalog, setCatalog] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    cdoBiome.selectAll((failure, result) => {
      if (!active) return;
      if (failure || result?.error) setError('Could not load biomes. Existing selections are preserved.');
      else setCatalog(Array.isArray(result) ? result : []);
    });
    return () => { active = false; };
  }, []);
  const changeLink = (index, field, nextValue) => onChange(value.map((link, row) =>
    row === index ? { ...link, [field]: nextValue } : link));

  return <section className="editor-section template-wide">
    <h3>Biomes</h3>
    <p className="panel-copy">Choose the surrounding environments and habitat features. Settlement and Farmland describe managed land; also choose its natural environment.</p>
    {error && <div role="alert">{error}</div>}
    {value.map((link, index) => <div className="template-link-row" key={index}>
      <label className="editor-field"><span className="field-label">Biome</span>
        <select className="select-input" required value={link.idBiome ?? ''} disabled={!catalog.length}
          onChange={event => changeLink(index, 'idBiome', event.target.value === '' ? '' : Number(event.target.value))}>
          <option value="">Select...</option>
          {link.idBiome && !catalog.some(biome => String(biome.idBiome) === String(link.idBiome)) &&
            <option value={link.idBiome}>{link.name || `Biome ${link.idBiome}`}</option>}
          {catalog.map(biome => <option key={biome.idBiome} value={biome.idBiome}
            disabled={value.some((other, row) => row !== index && String(other.idBiome) === String(biome.idBiome))}>
            {biome.name}
          </option>)}
        </select>
      </label>
      <label className="editor-field"><span className="field-label">Weight</span>
        <input className="text-input" type="number" min="0.000001" step="any" required value={link.weight ?? 1}
          onChange={event => changeLink(index, 'weight', event.target.value)} />
      </label>
      <label className="editor-field"><span className="field-label">Notes</span>
        <input className="text-input" maxLength={255} value={link.notes ?? ''}
          onChange={event => changeLink(index, 'notes', event.target.value)} />
      </label>
      <button type="button" className="secondary-button"
        onClick={() => onChange(value.filter((_, row) => row !== index))}>Remove Biome</button>
    </div>)}
    <button type="button" className="secondary-button" disabled={!catalog.length}
      onClick={() => onChange([...value, { idBiome: '', weight: 1, notes: '' }])}>Add Biome</button>
  </section>;
}
